<template>
  <div class="signup app-content bg-gray">
    <div class="container">
      <div class="row pt-4 ">
        <div class="col-12">
          <router-link :to="'./mypage'">
            <p class="text-dark font14 under" style="display: inline;">{{$t("message.top")}}</p>
          </router-link> 
          <p class="mx-1 text-dark font14" style="display: inline;"> > </p>
          <router-link :to="'./account_setting'">
            <p class="text-dark font14 under" style="display: inline;">{{$t("message.account_setting")}}</p>
          </router-link> 
        </div>
      </div>
      <div class="row mt-4">
        <div class="col-12">
          <h5>{{$t("message.account_setting")}}</h5>
        </div>
        <div class="col-12">
          <div class="list-group">
            <a href='./email_setting' class="list-group-item list-group-item-action flex-column align-items-start">
              <div class="d-flex w-100 justify-content-between" >
                <p class="mb-0 w-65">{{$t("message.changeEmail")}}</p>
                <p class="text-muted mb-0  w-35 text-right text-hidden">{{user.attributes.email}}<span class="text-dark mgl-20"><b>></b></span></p>
              </div>
            </a>
            <a href="./password_setting" class="list-group-item list-group-item-action flex-column align-items-start" v-if="isSNS == false">
              <div class="d-flex w-100 justify-content-between" >
                <p class="mb-0 w-65">{{$t("message.changePassword")}}</p>
                <p class="text-muted mb-0 w-35 text-right"><span class="text-dark mgl-20"><b>></b></span></p>
              </div>
            </a>
          </div>
        </div>
      </div>

      <div class="row mt-4">
        <div class="col-12">
          <h5>{{$t("message.about_withdrawal_subsc")}}</h5>
        </div>

        <div class="col-12 pb-4">
          <div class="list-group">
            <a href='./deactivate' class="list-group-item list-group-item-action flex-column align-items-start">
              <div class="d-flex w-100 justify-content-between" >
                <p class="mb-0">{{$t("message.apply_withdrawal")}}</p>
                <p class="text-muted mb-0 "><span class="text-dark mgl-20"><b>></b></span></p>
              </div>
            </a>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'; 
export default {
  data () {
    return {
      isSNS: false
    }
  },
  methods: {
  },
  computed: {
    ...mapState({
      user: state => state.user.outh,
      memberInfo: state => state.user.user
    }),
  },
  mounted(){
    if(this.user.username.match(/Google|Facebook|LINE/) != null){
      this.isSNS = true
    }
    this.$store.commit('setLoading', false)
  },

}
</script>

<style scoped>
.w-65{
  width: 65%;
}
.w-35{
  width: 35%;
}
.text-hidden{
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
